
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AssistantErrorProps {
  error: string;
  onRetry: () => void;
}

const AssistantError: React.FC<AssistantErrorProps> = ({ error, onRetry }) => {
  return (
    <>
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription className="text-sm">
          Failed to load assistants: {error}
        </AlertDescription>
      </Alert>
      <div className="text-center mt-4">
        <Button variant="outline" size="sm" onClick={onRetry} className="flex items-center gap-2">
          <RefreshCw className="h-4 w-4" />
          <span>Retry</span>
        </Button>
      </div>
    </>
  );
};

export default AssistantError;
